/**
 * LogLevel
 * This valriable defines all the log levels with a numerical
 * value
 */
export enum LogLevel {
    /**
     * debug log level will log all types of logs
     */
    debug,

    /**
     * info log level will log info, warning and error logs only
     */
    info,

    /**
     * warning log level will log warning and error logs only
     */
    warning,

    /**
     * error log level will log error logs only
     */
    error,

    /**
     * mute log level will hide all logs
     */
    mute,
}